export default "__VITE_ASSET__D5OIppw4__"